import MagnifyingGlass from "@/assets/svg/creator-shield/magnifying-glass.svg";
import MoneyBag from "@/assets/svg/creator-shield/money-bag.svg";
import Watch from "@/assets/svg/creator-shield/watch.svg";

export default function SimpleProcess() {
  const steps = [
    {
      icon: Watch,
      time: "Every 2 seconds",
      description:
        "Someone will steal and upload a CreatorShield client's video, stealing the ad-revenue",
    },
    {
      icon: MagnifyingGlass,
      time: "It takes us 0.5 seconds",
      description:
        "To identify stolen uploads and issue a monetization claim, which routes the revenue back to you!",
    },
    {
      icon: MoneyBag,
      time: "Every 30 days",
      description:
        "You'll be paid your part of $1.5M per month we currently re-capture for clients",
    },
  ];

  return (
    <div className="bg-white p-24 pb-40 px-6 md:px-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto space-y-16">
        <div className="text-center space-y-4">
          <p className="text-[#FF6B35] font-semibold text-lg md:text-xl uppercase tracking-wide">
            SIMPLE PROCESS
          </p>
          <h2 className="leading-tight text-5xl lg:text-6xl font-semibold text-black">
            Learn more <span className="text-[#FF6B35]">about the process</span>
          </h2>
          <p className="text-lg md:text-xl text-black max-w-2xl mx-auto">
            Three simple steps to start earning from your stolen content.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-20 lg:gap-24 max-w-5xl mx-auto">
          {steps.map((step, index) => {
            const IconSrc = step.icon;
            return (
              <div
                key={index}
                className="flex flex-col gap-6 items-center text-center"
              >
                <img src={IconSrc} alt="" className="w-[60px] h-[60px]" />
                <div className="flex flex-col gap-4 items-center">
                  <div className="text-xl md:text-2xl font-semibold text-black">
                    {step.time}
                  </div>
                  <div className="text-sm md:text-base text-black leading-relaxed">
                    {step.description}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
